import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SideNavBarVisibilityService } from 'src/app/services/side-nav-bar-visibility.service';
import { IUser } from 'src/app/models/user.model';
import { UserInfoService } from 'src/app/services/user-info.service';
import { ZpDataService } from 'src/app/services/zp-data.service';
import { ThemeService } from 'src/app/theme/theme-service.service';


@Component({
  selector: 'app-reset-password-email',
  templateUrl: './reset-password-email.component.html',
  styleUrls: ['./reset-password-email.component.scss']
})
export class ResetPasswordEmailComponent implements OnInit {
  public parentForm: FormGroup;
  public submitted = false;
  public myUser: IUser;
  public displayNextStep = false;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private userInfoService: UserInfoService,
    private ZpDataService: ZpDataService,
    public themeService: ThemeService) { }

  ngOnInit() {
    this.parentForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
    this.sideNavBarVisibilityService.hideSideNav = true;
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.parentForm.controls;
  }

  async onSubmit() {
    this.submitted = true;
    if (this.parentForm.invalid) {
      return;
    } else {
      let res = await this.ZpDataService.requestPasswordReset(this.parentForm.value.email);
      if (res.success) {
        this.displayNextStep = true;
      } else {
        alert(res.message);
      }
    }
  }

  goto(url: string) {
    this.submitted = false;
    this.router.navigate(['/' + url]);
  }

  onReset() {
    this.submitted = false;
    this.parentForm.reset();
  }
}
